import { Paper, Typography } from "@mui/material";
import Chart from "react-apexcharts";
import { lineChartData, lineChartOptions } from "../../../../data/chartData";

const LineChart = () => {
  return (
    <Paper
      sx={{
        boxShadow: "none !important",
        borderRadius: "12px",
        padding: "15px",
        height: { xs: "380px", md: "100%" },
        borderStyle: "solid",
        borderWidth: "1px",
        borderColor: "divider",
      }}
    >
      <Typography variant="h5">Appointment Statistics</Typography>
      <Chart
        options={lineChartOptions}
        series={lineChartData}
        type="line"
        width="100%"
        height="90%"
      />
    </Paper>
  );
};

export default LineChart;
